<template>
	<h1 v-if="showHeader" class="font-main-header">{{ $t("register.personalInformation") }}</h1>

	<ion-grid class="form-grid">
		<ion-row>
			<ion-col>

				<ion-item>
					<ion-input label-placement="stacked" :label="$t('register.lastname')" class="input-medium"
						v-model="form.familyName" required :aria-label="$t('register.lastname')" />
					<ion-note class="input-helper" v-if="formErrors.familyName || formErrors.firstName" color="danger">
						{{ formErrors.familyName }} {{ formErrors.firstName }}
					</ion-note>
				</ion-item>
			</ion-col>

			<ion-col size="5">
				<ion-item>
					<ion-input label-placement="stacked" :label="$t('register.firstname')" class="input-medium"
						v-model="form.firstName" required :aria-label="$t('register.firstname')" />
				</ion-item>
			</ion-col>
		</ion-row>

		<ion-row>
			<ion-col>
				<ion-item>
					<ion-input label-placement="stacked" :label="$t('register.phone')" class="input-large"
						v-model="form.phone" required pattern="[0-9]+" :aria-label="$t('register.phone')" />
					<ion-note class="input-helper" v-if="formErrors.phone" color="danger">
						{{ formErrors.phone }}
					</ion-note>
				</ion-item>
			</ion-col>
		</ion-row>
		<ion-row>
			<ion-col  v-if="this.activeHost.useGenderSelector">
                <ion-label position="stacked">{{ $t('register.gender') }}</ion-label>
					<GenderSelector :gender="form.gender" @update:gender="form.gender = $event" />
			</ion-col>
		</ion-row>
		<ion-row>
			<ion-col>
				<ion-item>
					<ion-input label-placement="stacked" :label="$t('register.email')"
						:helperText="$t('account.changingEmailNote')" class="input-large" v-model="form.email" required
						type="mail" :aria-label="$t('register.email')" />

					<ion-note class="input-helper" size="12" v-if="formErrors.email" color="danger">
						{{ formErrors.email }}
					</ion-note>
				</ion-item>
			</ion-col>


		</ion-row>
	</ion-grid>

	<template v-if="settings.usePersonAdressInformation === true">
		<ion-grid class="form-grid">
			<ion-row>
				<ion-col>
					<ion-item>
						<ion-input label-placement="stacked" :label="$t('register.address')" class="input-large"
							v-model="form.streetAddress" required :aria-label="$t('register.address')"></ion-input>
					</ion-item>
				</ion-col>
			</ion-row>

			<ion-row>
				<ion-col size="4">
					<ion-item>
						<ion-input label-placement="stacked" :label="$t('register.zip')" class="input-medium"
							v-model="form.postalCode" required :aria-label="$t('register.zip')"></ion-input>
					</ion-item>
				</ion-col>

				<ion-col>
					<ion-item>
						<ion-input label-placement="stacked" :label="$t('register.city')" class="input-medium"
							v-model="form.city" required pattern="[^0-9]{1,30}"
							:aria-label="$t('register.city')"></ion-input>
					</ion-item>
				</ion-col>
			</ion-row>

			<ion-row>
				<ion-col size="6">
					<ion-label position="stacked">
						{{ $t("register.birthday") }}
					</ion-label>
					<div
						v-if="dpOpen"
						class="wn-blur-backdrop"
						@click="dpOpen = false"
					></div>
					<Datepicker v-model="form.birthday" :locale="$i18n.locale" :dark="$store.getters['common/darkMode']"
						:week-start="1" :enable-time-picker="false" format="dd.MM.yyyy" 
						teleport-center     
						@open="dpOpen = true"
						@closed="dpOpen = false"
						:select-text="$t('select')"
						:cancel-text="$t('cancel')">
						<template #input="{ value, onInput, onFocus, onBlur }">
							<input :value="value" @input="onInput" @focus="onFocus" @blur="onBlur"
								class="wn-datepicker" />
						</template>
					</Datepicker>
				</ion-col>

				<ion-col>
					<ion-item class="input-medium ion-no-border">
						<ion-label position="stacked">
							{{ $t("register.country") }}
						</ion-label>
						<WiseCountrySelector :countrySetting="true" v-model="form.country" />
					</ion-item>
				</ion-col>

			</ion-row>

		</ion-grid>
	</template>

	<div>
		<!-- Form validation errors -->
		<p v-if="formErrors?.length && false" class="ion-padding-bottom">
		<ul>
			<ion-text color="danger">
				<li v-for="(error, index) in formErrors" :key="index">{{ error }}</li>
			</ion-text>
		</ul>
		</p>

		<ion-button size="large" color="success" expand="block" @click="sendUserData()">
			{{ $t("account.editSave") }}
		</ion-button>


	</div>

	<ion-button v-if="showDeleteButton" expand="block" color="danger" size="large" @click="openDeletionAlert()">
		{{ $t("account.deleteUser") }}
	</ion-button>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import axios from 'axios';
import GenderSelector from '@/WiseGym/components/GenderSelector.vue';
import { countryCodes } from '../countryCodes';
import { alertController, loadingController } from "@ionic/vue";

	// function handlePhoneNumber(code, number) {
	// 		if (number.length === 0) return '';
	// 		if (number.length >= 10 && number[0] == 0) {
	// 			number = number.substring(1, number.length)
	// 		}
		
	// 		return `${ code }${ number }`
	// 	}

export default {
	name: "WiseRegisterForm",
	props: {
		userOverride: { type: Object, default: null },
		forceMainUser: { type: Boolean, default: false },
		showDeleteButton: { type: Boolean, default: true },
		showHeader: { type: Boolean, default: true }
	},
	data() {
		return {
			formErrors: [],
			countryCodes,
			form: {
				firstName: "",
				familyName: "",
				email: "",
				phone: "",
				streetAddress: "",
				postalCode: "",
				city: "",
				birthday: null,
				country: "FI",
				gender: ""
			},
			selectedCountry: 'FI',
			loading: false,
			dpOpen: false
		}
	},
	components: {GenderSelector},
	computed: {
		...mapState({
			user: state => state.user.user,
			parentUser: state => state.user.parentUser,
			settings: state => state.common.settings,
			userLocale: state => state.common.userLocale,
			selectedHost: state => state.common.selectedHost,
			consentCheckboxText: state => state.common.consentCheckboxText,
			subProfileActive: state => state.user.subProfileActive
		}),

		...mapGetters({ activeHost: "common/activeHost" }),
		countries() {
			return this.countriesList;
		},
		availableHosts() {
			return this.settings.hosts.filter(row => !row.disableRegistration);
		},
		selectedClubNonWiseClub() {
			if (this.availableHosts.length === 0) return false;

			const clubId = this.form.golfClubId;

			if (clubId == 99999 || clubId == 99998) return true;

			return this.availableHosts.filter(row => row.golfClubId == clubId).length === 0;
		},
	},
	methods: {
		...mapActions({ deleteUser: "user/deleteUser"}),

		async loadingOverlay() {
			this.loading = await loadingController.create({
				cssClass: "wise-login-overlay",
			});
			await this.loading.present();
		},

		async removeAndLogout() {
			try {
				const data = await this.deleteUser();
				if (data.data.error) {
					throw new Error(data.data.error.text);

				} else if (this.subProfileActive && !data.data.error){
					console.log('before error check:', data.data);
					this.$router.go(-1)
					this.loading.dismiss();
					this.$store.commit("user/clearSubProfileActive")
					const alert = await alertController.create({
					mode: 'ios',
					header: `${this.$t("account.userDeleteSuccess")}`,
					buttons: [
						{
							text: this.$t('close'),
							role: 'cancel'
						}
					]
				})
				await alert.present();
				} else {
					await this.$store.dispatch('user/logOut');
					this.$router.replace('/');
					this.loading.dismiss();
				}
			} catch (error) {
				//console.log("deleteUser:", error)
				this.loading.dismiss();
				const alert = await alertController.create({
					mode: 'ios',
					header: `${this.$t("account.userDeletionErrorHeader")}`,
					message:  error.message + '\n' + `${this.$t("account.userDeletionErrorDescriptionText")}`,
					buttons: [
						{
							text: this.$t('close'),
							role: 'cancel'
						}
					]
				})
				await alert.present();
			}
		},

		async openDeletionAlert() {
			const alert = await alertController.create({
                        mode: 'ios',
                        header: this.$t("account.deleteUserConfirmationHeader"),
                        message: `${this.$t("account.deleteUserDescriptionText")}`,
                        buttons: [
                            {
                                text: this.$t("cancel"),
                                role: 'cancel'
                                },
                            {
								text: this.$t("confirm"),
								role: 'success',
								handler: async () => {
									this.loadingOverlay();
									//console.log('Trying to remove user');
									this.removeAndLogout();
								}
							}
                        ]
                    });

			await alert.present();
		},

		// parsePhoneNumber(number, countryCodes) {
		// for (var countryCode of countryCodes) {
		// 	if (number.startsWith(countryCode.code)) {
		// 		number = number.substring(countryCode.code.length)
		// 		this.selectedCountry = countryCode.country;
		// 		return number;
		// 	}
		// 	else if ( number.startsWith(0)) {
		// 		number = number.toString();
		// 		number = number.substring(0)
		// 		number = Number(number)
		// 		return number
		// 	}
		// 	return number
		// }
		// },

		// Submits account edit
		async sendUserData() {
			// Format dates to DD.MM.YYYY
			if (this.form.birthday) {
				this.form.dateOfBirth = this.$filters.dateShort(this.form.birthday)
			}
				// Submit edit form
					try {
						//const [ country ] = this.countryCodes.filter(row => row.country === this.selectedCountry)
						const form = {
							...this.form,
							//phone: handlePhoneNumber(country.code, this.form.phone)
						}
						let response
						//console.log('sendUserData', form)
						// QUESTION: Should we ask password confirm when update accound data?
						if (this.userOverride && !this.forceMainUser) {
							const personId = this.userOverride.personId
							const userId = this.userOverride.userId
							response = await axios.post(`${this.activeHost.ajaxUrl}?appuserdetail=1&appauth=${this.activeHost.appauth}&lang=${this.userLocale}`, form,
							{
								params: { personLinkReq: 1, personId: personId, userId: userId }
							});
						} else if (this.subProfileActive && !this.forceMainUser) {
							const personId = this.user.personId
							const userId = this.user.userId
							response = await axios.post(`${this.activeHost.ajaxUrl}?appuserdetail=1&appauth=${this.activeHost.appauth}&lang=${this.userLocale}`, form,
							{
								params: { personLinkReq: 1, personId: personId, userId: userId}
							});
						} else {
							response = await axios.post(`${this.activeHost.ajaxUrl}?appuserdetail=1&appauth=${this.activeHost.appauth}&lang=${this.userLocale}`, form);
						}
						const data = response.data;
						this.formErrors = [];
						if (Array.isArray(data.errors)) {
							this.$_wiseAlert({
								mode: 'ios',
								message: data.errors.join("\n"),
								buttons: [{ text: 'OK' }]
							})
							//data.errors.forEach(error => this.formErrors.push(error))
						} else if (typeof data.errors === 'string') {
							this.$_wiseAlert({
								mode: 'ios',
								message: data.errors,
								buttons: [{ text: 'OK' }]
							})
						}

						if (data.success) {
							// Delete unneeded keys from response to get "plain" user object
							delete data['success', 'debug', 'tempDebug'];
							// Only update store when editing the active user, not a linked person
							if (this.userOverride) {
								// Editing a linked person — don't touch store state
							} else if (this.forceMainUser) {
								Object.assign(this.parentUser, data);
							} else {
								Object.assign(this.user, data);
							}

							const alert = await alertController.create({
								header: this.$t("account.editSuccess"),
								buttons: ["Ok"]
							});

							alert.onDidDismiss().then(() => {
								this.$router.back()
							})
							return alert.present();
						}
					} catch (e) {
						console.log('appuserdetail', e)
					}

		},

	},
	async mounted() {
		const source = this.forceMainUser
			? (this.parentUser || this.user)
			: (this.userOverride || this.user)
		this.form.firstName = source?.firstName
		this.form.familyName = source?.familyName
		this.form.email = source?.email
		this.form.phone = source?.phone
		this.form.streetAddress = source?.streetAddress
		this.form.postalCode = source?.postalCode
		this.form.city = source?.city
		this.form.country = source?.country || 'FI'
		this.form.gender = source?.gender
		this.form.birthday = source?.dateOfBirth ? source?.dateOfBirth : null
		this.form.guardianName = source?.guardianName
		this.form.guardianBirthday = source?.guardianSSN ? source?.guardianSSN : null
		this.form.guardianPhone = source?.guardianPhone
		this.form.guardianEmail = source?.guardianEmail
	},
};
</script>

<style scoped>

</style>